module.exports = __webpack_public_path__ + "static/img/pop_up_bg.5c573ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/popup/pop_up_bg.png
// module id = PavO
// module chunks = 1